/*
 * @Date: 2021-07-22 16:41:28
 * @LastEditTime: 2021-07-27 14:51:23
 * @LastEditors: Please set LastEditors
 * @FilePath: \shangwu_web\src\views\demonstration\demonstration.js
 */

// import { name } from '@apis/apis'
import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
import parksMap from '../demonstration/map/parksMap.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import {getPVUV} from '../../apis/apis'
export default {
  name: 'demonstration',
  data(){
    return {
      activeIndex:'1',
      tab: 3,
      //示范园区tab选项
      p_checked: 0,
      //示范企业tab选项
      e_checked: 0,
      //示范企业中城市tab选项
      c_checked:1,
      
      // 城市列表
      cityList: [
        {
          id: "1",
          name:"合肥市",
        },
        {
          id: "2",
          name:"六安市",
        },
        {
          id: "3",
          name:"蚌埠市",
        },
        {
          id: "4",
          name:"合肥市",
        },
        {
          id: "5",
          name:"六安市",
        },
        {
          id: "6",
          name:"蚌埠市",
        },
        {
          id: "7",
          name:"合肥市",
        },
        {
          id: "8",
          name:"六安市",
        },
        {
          id: "9",
          name:"蚌埠市",
        },
        {
          id: "10",
          name:"合肥市",
        },
        {
          id: "11",
          name:"六安市",
        },
        {
          id: "12",
          name:"蚌埠市",
        },
        {
          id: "13",
          name:"合肥市",
        },
        {
          id: "14",
          name:"六安市",
        },
        {
          id: "15",
          name:"蚌埠市",
        },
        {
          id: "16",
          name:"合肥市",
        },
        {
          id: "17",
          name:"六安市",
        },
        {
          id: "18",
          name:"蚌埠市",
        },
      ],
      // 判断点击了哪个菜单
      type: '1',
      nowyears: 0,
      index1:'',
      index2:'',
      index3:'',
      index4:'',
      index5:'',
    }
  },
  
  mounted(){
    //渲染城市列表
    this.renderCities()
    //渲染示范企业列表
    this.renderEnterprise()
    // this.getyears()
    this.getpvuv()
  },

  methods: {
    // 埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "示范创建",
        directoryTwo: null,
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    //点击位置导航进行跳转
    navPosition(name){
      this.$router.push({name})
    },
    changeTab(val) {
      this.tab = val
    },
    changeTabs(v) {
      this.activeIndex = v;
      // 区分请求接口
      if (v === "1" || v === "2") {
        this.type = v;
        // 产业园区
        this.$refs.mapRef.getParksNum(this.type);
      } else {
        this.type = v;
        let curType = 0;
        switch(this.type) {
        case '3':
          curType = '1';
          break;
        case '4':
          curType = '2';
          break;
        case '5':
          curType = '0';
          break;
        }
        // 示范企业
        this.$refs.mapRef.getEnterpriseNum(curType);
      }
    },

    /**
     * @description:渲染示范企业 城市列表
     * @param {*}
     */    
    renderCities() {
      new Swiper ('.swiperCity', {
        slidesPerView : 16,
        // spaceBetween : 10,
        observer:true,
        observeParents: true,
        preventClicks : false,
      })
    },
    /**
     * @description:渲染示范企业列表
     * @param {*}
     */    
    renderEnterprise() {
      new Swiper ('.swiperEnterprise', {
        slidesPerView : 3,
        spaceBetween : 25,
        observer:true,
        observeParents: true,
        preventClicks: false,
      })
    },
    /**
     * @description: 跳转去企业详情页
     * @param {*}
     */    
    detailPage() {
      this.$router.push({name:'detailPage'})
    },
    /**
     * @description: 城市Tab栏切换 返回不同企业
     * @param {*} key为进行查询的城市Code
     */    
    citiesTab(key) {
      this.c_checked = key
      // console.log(key)
    },
  },

  components: {
    'web-head': Head,
    'web-foot': Foot,
    'parksMap': parksMap,
  }
}